import { useIntegratedActionBroadcaster } from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useOpenEventPanel } from '../../event-panel/use-open-event-panel';
import { v4 } from 'uuid';

type UseUpdateDispositionModalProps = {
    eventId?: number;
    unitId?: number;
    isPrimaryUnit?: boolean;
    isTriggeredFromEventPanel?: boolean;
};
export const useUpdateDispositionModal = ({
    eventId,
    unitId,
    isPrimaryUnit,
    isTriggeredFromEventPanel,
}: UseUpdateDispositionModalProps) => {
    const { trigger } = useIntegratedActionBroadcaster();

    const openEventPanel = useOpenEventPanel();

    const openEventPanelAndShowUpdateDispositionModal = (): void => {
        if (!eventId) {
            return;
        }
        if (!isTriggeredFromEventPanel) {
            openEventPanel({
                eventId,
            });
        }
        trigger([
            {
                targetWindowType: 'EVENT_V2',
                id: v4(),
                type: 'SHOW_UPDATE_DISPOSITION_MODAL',
                payload: {
                    eventId,
                    unitId,
                    isPrimaryUnit: !!isPrimaryUnit,
                },
            },
        ]);
    };
    return { openEventPanelAndShowUpdateDispositionModal };
};
